import {
    isFreeTextDataResult,
    isSparePartsDataResult,
    isTypeDesignationDataResult,
} from '@ecs-services/search/search.helper';
import {
    FreeTextDataResult,
    SparePartsDataResult,
    TypeDesignationDataResult,
} from '@ecs-services/search/search.interface';
import { ActionCreator, Creator, on, ReducerTypes } from '@ngrx/store';
import { OnReducer, reducerFilter } from '../../../store.helper';
import { SearchState } from '../../search.reducer';
import * as SparePartActions from './spare-part.actions';

const sparePartStateReducer =
    <Creators extends readonly ActionCreator[]>(
        reducer: OnReducer<
            SearchState<SparePartsDataResult | FreeTextDataResult | TypeDesignationDataResult>,
            Creators
        >
    ): OnReducer<SearchState, Creators> =>
    (state: SearchState, action) =>
        reducerFilter(
            (
                unfilteredState: SearchState
            ): unfilteredState is SearchState<
                SparePartsDataResult | FreeTextDataResult | TypeDesignationDataResult
            > =>
                isSparePartsDataResult(unfilteredState.searchResult) ||
                isTypeDesignationDataResult(unfilteredState.searchResult) ||
                isFreeTextDataResult(unfilteredState.searchResult),
            reducer
        )(state, action);

export const sparePartReducers: ReducerTypes<
    SearchState,
    readonly ActionCreator<string, Creator<any[], any>>[]
>[] = [
    on(
        SparePartActions.receiveSparePartsAvailability,
        sparePartStateReducer((state, { payload: { sparePartsWithAvailability } }) => ({
            ...state,
            searchResult: {
                ...state.searchResult,
                ...(state.searchResult.spareParts
                    ? {
                          ...state.searchResult,
                          spareParts: [
                              ...state.searchResult.spareParts.map((sparePart) => ({
                                  ...sparePart,
                                  availability: sparePartsWithAvailability.find(
                                      (sparePartWithAvailability) =>
                                          sparePartWithAvailability.sparePartId === sparePart.id
                                  )?.availability,
                              })),
                          ],
                      }
                    : {}),
            },
        }))
    ),
];
